import { useContext } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useFDMServices } from '../../../../../providers/fdm-services/fdm-services.context';
import { MutationKeys, QueryKeys } from '../../../../../utils/queryKeys';

import { UseDeleteInfieldLocationConfigMutationContext } from './use-delete-infield-location-config-mutation.context';

export const useDeleteInfieldLocationConfig = () => {
  const { captureException } = useContext(
    UseDeleteInfieldLocationConfigMutationContext
  );
  const { apmClient } = useFDMServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string[]>({
    mutationFn: async (infieldLocationsConfigToDelete) => {
      await apmClient.infieldLocationConfig.delete(
        infieldLocationsConfigToDelete
      );
    },
    onError: (err) => {
      captureException(err);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.INFIELD_LOCATION_CONFIG],
      });
    },
    mutationKey: [MutationKeys.USE_INFIELD_LOCATION_CONFIG_DELETE],
  });
};
